(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zeus-transformationpro"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Before / After drag logic */
  function initBeforeAfterSliders(context) {
    var root = context || document;
    var sliders = root.querySelectorAll('[data-ba-slider]');
    if (!sliders.length) return;

    sliders.forEach(function(slider) {
      var beforeWrap = slider.querySelector('[data-ba-before]');
      var divider = slider.querySelector('[data-ba-divider]');
      if (!beforeWrap || !divider) return;

      var dragging = false;

      function updatePosition(clientX) {
        var rect = slider.getBoundingClientRect();
        var x = clientX - rect.left;
        var pct = (x / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));

        beforeWrap.style.width = pct + '%';
        divider.style.left = pct + '%';
      }

      function startDrag(e) {
        dragging = true;
        if (e.type === 'mousedown') {
          updatePosition(e.clientX);
        } else if (e.touches && e.touches[0]) {
          updatePosition(e.touches[0].clientX);
        }
      }

      function moveDrag(e) {
        if (!dragging) return;
        if (e.type === 'mousemove') {
          updatePosition(e.clientX);
        } else if (e.touches && e.touches[0]) {
          updatePosition(e.touches[0].clientX);
        }
      }

      function endDrag() {
        dragging = false;
      }

      slider.addEventListener('mousedown', startDrag);
      slider.addEventListener('touchstart', startDrag, { passive: true });
      window.addEventListener('mousemove', moveDrag);
      window.addEventListener('touchmove', moveDrag, { passive: true });
      window.addEventListener('mouseup', endDrag);
      window.addEventListener('touchend', endDrag);
    });
  }

  /* Mobile carousel logic (arrows + dots) */
  function initTransformCarousels(context) {
    var root = context || document;
    var sections = root.querySelectorAll('.zeus-trans.zeus-trans--mCarousel');
    if (!sections.length) return;

    sections.forEach(function(section) {
      var list = section.querySelector('[data-trans-list]');
      if (!list) return;

      var items = list.querySelectorAll('[data-trans-item]');
      if (items.length <= 1) return;

      var prevBtn = section.querySelector('[data-trans-prev]');
      var nextBtn = section.querySelector('[data-trans-next]');
      var dots = section.querySelectorAll('[data-trans-dot]');
      if (!prevBtn || !nextBtn) return;

      var current = 0;

      function setActive(index) {
        var total = items.length;
        if (!total) return;

        index = (index + total) % total; /* wrap */
        current = index;

        items.forEach(function(item, i) {
          if (i === index) {
            item.classList.add('zeus-trans__item--active');
          } else {
            item.classList.remove('zeus-trans__item--active');
          }
        });

        dots.forEach(function(dot, i) {
          if (i === index) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });
      }

      prevBtn.addEventListener('click', function() {
        setActive(current - 1);
      });

      nextBtn.addEventListener('click', function() {
        setActive(current + 1);
      });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var idx = parseInt(dot.getAttribute('data-trans-dot'), 10);
          if (!isNaN(idx)) setActive(idx);
        });
      });

      /* Initialize */
      setActive(0);

      window.addEventListener('resize', function() {
        setActive(current);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initBeforeAfterSliders(document);
    initTransformCarousels(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initBeforeAfterSliders(event.target);
    initTransformCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
